<template>
    <div>
        <span>
            {{ introText }}
        </span>

        <div class="bg-neutral-lighter py-lg my-lg px-xl -mx-2xl -mb-2xl">
            <div class="button-group flex-row-reverse">
                <button
                    type="button"
                    class="btn btn-lg is-primary ml-auto"
                    @click="$emit('next')"
                >
                    {{ lang('Starta guiden','Start guide') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                introText: lang(
                    'Vi ser att du har en Ownit-router, grattis! Din router har några inställningar som det vore bra om vi går igenom. Vill du göra det nu?',
                    'You seem to have a router from Ownit, congratulations! Would you mind stepping through a wizard to complete the router settings?'
                ),
            };
        },
        mounted() {
            this.$emit(
                'title',
                lang('Välkommen till Ownits routerguide', 'Welcome to the Ownit router wizard!')
            );
        },
        methods: {
        },
    };
</script>